// extracted by mini-css-extract-plugin
export default {"rewriteSuccess":"rewriteSuccess_SjXer","rewriteFail":"rewriteFail_tlkMi"};